var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-auto"},[_c('a',{staticClass:"logo",attrs:{"href":_vm.url}},[_c('img',{attrs:{"src":require('@/assets/static/images/auth_logo.svg'),"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.$t('app.beta')))])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }